// src/features/dashboard/components/EmployeeCompliance/ComplianceHeader.tsx

import {
  ComplianceHeaderData,
} from "../../types/Employee/employeeCompliance.types";

import {
  getEmployeeName,
} from "../../../auth/utils/Login/authStorage";

interface Props {
  header: ComplianceHeaderData | null;
}

const ComplianceHeader = ({ header }: Props) => {
  if (!header) return null;

  const employeeName = getEmployeeName() || "--";

  const login = header.badge.login?.trim() || "--";
  const breaks = header.badge.breaks?.trim() || "--";
  const hours = header.badge.hours?.trim() || "--";
  const policy = header.badge.policy?.trim() || "--";
  const week = header.badge.week?.trim() || "--";

  return (
    <div className="flex flex-wrap items-center gap-3">
      <h2 className="text-[14px] font-semibold text-[#002B5B]">
        Compliance · {header.gatesMet} of {header.totalGates} Gates Met
      </h2>

      <span
        className="
          rounded-full
          bg-[#EEF4FF]
          px-3
          py-1
          text-[11px]
          font-medium
          text-[#2563EB]
        "
      >
        {employeeName} ·
        {" "}Login · {login} ·
        {" "}Breaks · {breaks} ·
        {" "}Hours · {hours} ·
        {" "}Policy · {policy} ·
        {" "}WTD {week}
      </span>
    </div>
  );
};

export default ComplianceHeader;